import React from 'react';
import { IBookingEvent } from '../../../../types';
import {
  DropdownFilters,
  NoResults,
  TopicFilter,
} from '../../../shared/filters';
import useOfferingFilters from './use-offering-filters';

interface FilteredEventsProps {
  upcomingEvents: IBookingEvent[];
  render: (
    filteredUpcomingEvents: IBookingEvent[],
    loading: boolean,
  ) => React.ReactNode;
}

const FilteredOfferings = ({ upcomingEvents, render }: FilteredEventsProps) => {
  const {
    availableTopics,
    handleChangeTopic,
    handleTypeFilterChange,
    handleLanguageFilterChange,
    topic,
    eventTypeFilter,
    languageFilter,
    getTypeFilterOptions,
    getFilterOptions,
    filteredUpcomingEvents,
    languages,
    loading,
    handleResetFilters,
  } = useOfferingFilters({ upcomingEvents });

  const dropdownFilters = [
    {
      name: 'eventTypeFilter',
      value: eventTypeFilter,
      onChange: handleTypeFilterChange,
      options: getTypeFilterOptions(),
    },
    {
      name: 'languageFilter',
      value: languageFilter,
      onChange: handleLanguageFilterChange,
      options: getFilterOptions(languages),
    },
  ];

  return (
    <>
      <TopicFilter
        availableTopics={availableTopics}
        onChange={handleChangeTopic}
        topic={topic}
      />

      <DropdownFilters filters={dropdownFilters} />

      {filteredUpcomingEvents?.length > 0 ? (
        render(filteredUpcomingEvents, loading)
      ) : (
        <NoResults onReset={handleResetFilters} />
      )}
    </>
  );
};

export default FilteredOfferings;
